<template>
  <v-menu v-model="menu" transition="slide-y-transition" bottom :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="menu = true" v-on="on">
            <v-icon>
              {{ icon }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $vuetify.lang.t('$vuetify.map.criticalPopup.criticalStatisticsFilterMenu.popup') }}</span>
      </v-tooltip>
    </template>

    <v-card max-width="350">

      <v-toolbar>
        <v-toolbar-title>
          <span class="subtitle-1">{{ $vuetify.lang.t('$vuetify.map.criticalPopup.criticalStatisticsFilterMenu.title') }}</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="menu = false">
          <v-icon>{{ closeIcon }}</v-icon>
        </v-btn>

        <v-progress-linear :active="isLoading" indeterminate absolute bottom>
        </v-progress-linear>
      </v-toolbar>

      <v-card-text class="pb-0">
        <v-row align="center" justify="space-around">
          <v-col v-for="item in filterData" :key="item.postfix" md="1" cols="1" class="px-2 mx-1 cell_width">
            <div class="text-center">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon class="pointer" left :color="item.color" v-on="on">{{ item.icon }}</v-icon>
                </template>
                <span>{{ $vuetify.lang.t(item.title) }}</span>
              </v-tooltip>
              <span class="subtitle-1">
                <v-text-field v-model.number="filters[item.backend]" type="number" step="50" hint="ms"
                              :disabled="!usedFilters.includes(item.backend)"></v-text-field>
              </span>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="py-0">
        <v-spacer></v-spacer>
        <v-btn text color="green" @click="emitFilterCalculation">
          {{ $vuetify.lang.t('$vuetify.shared.apply') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mdiAvTimer, mdiClose } from '@mdi/js'
import { userAdditionalTripStatisticsFiltersList } from '../../../utils/travels'

export default {
  name: 'criticalStatisticsFilterMenu',
  props: {
    filters: Object,
    filterData: Array,
    isLoading: Boolean
  },
  data: () => ({
    menu: false,
    icon: mdiAvTimer,
    closeIcon: mdiClose,
    usedFilters: userAdditionalTripStatisticsFiltersList
  }),
  methods: {
    emitFilterCalculation () {
      this.$emit('filter-event-values')
    }
  },
  watch: {
    isLoading (value) {
      if (!value) {
        this.menu = false
      }
    }
  }
}
</script>

<style scoped>
  .cell_width {
    min-width: 70px;
  }
</style>
